import { Component, inject } from '@angular/core';
import { ConnectorService } from '../connector.service';
import { NavigationEnd, Router } from '@angular/router';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { NotificationsService } from '../notifications.service';
import { CompteService } from '../services/compte.service';
import { Account } from '../account/account.dto';
import { PointsHelpDialogComponent } from './points-help-dialog/points-help-dialog.component';
import { SocioCardDialogComponent } from '../socio-card/socio-card-dialog.component';

class navMenu {
  link: string = '';
  title: string = '';
  icon: string = '';
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  isConnected = true;
  readonly connectedMenus: navMenu[] = [];
  menuToDisplay: navMenu[] = [];
  compte: Account | null = null;

  deferredPrompt: any = null;

  constructor(
    private connector: ConnectorService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private http: HttpClient,
    public notificationsService: NotificationsService,
    private compteService: CompteService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.setIsConnected();
    
    // Subscribe to compte data
    this.compteService.compte$.subscribe(compte => {
      this.compte = compte;
    });
    
    // Fetch compte data if connected
    if (this.connector.isConnected()) {
      this.compteService.fetchCompte().subscribe();
    }
    
    this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationEnd) {
        this.setIsConnected();
        if(this.connector.isConnected()){
          // Refresh compte data on navigation
          this.compteService.fetchCompte().subscribe();
          setTimeout(() => {
            this.notificationsService.getInAppNotifications();
          }, 1000);
        }
      }
    });
  }

  ngAfterViewInit(): void {
    if(this.isInstallable()){
      this.checkInstall();
    }
    if(this.connector.isConnected()){
      // Fetch compte data after view init
      this.compteService.fetchCompte().subscribe();
      setTimeout(() => {
        this.notificationsService.getInAppNotifications();
      }, 1000);
    }
  }

  getHidden(num:number, receivePronoNotifications?:boolean){
    const displayProno = (receivePronoNotifications === undefined || receivePronoNotifications === true);
    if(num > 0 && displayProno){
      return 'false';
    }
    return 'hidden';
  }

  isInstallable(){
    return this.isMobile() && !this.isRunningInCapacitor() && !this.isRunningAsPWA();
  }

  // Detects if device is on iOS
  isIos(){
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod|macintosh/.test(userAgent);
  }

  isRunningInCapacitor(): boolean {
    return !!(window as any).Capacitor;
  }

  isRunningAsPWA(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches;
  }
                                
  // Detects if device is on iOS
  isSafari(){
    return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
        navigator.userAgent &&
        navigator.userAgent.indexOf('CriOS') === -1 &&
        navigator.userAgent.indexOf('FxiOS') === -1;
  }

  isMobile = () => {
    return window.innerWidth < 1025
  }

  hasNoNotifications(){
    const total = this.notificationsService.notifications.unreadDocs + this.notificationsService.notifications.missingPronostics + this.notificationsService.notifications.compteIssues + this.notificationsService.notifications.socioIssues + this.notificationsService.notifications.consultationsAvailable;
    return total === 0;
  }

  logoClick(){
    if(this.isConnected && this.hasNoNotifications() && this.isMobile()){
      this.router.navigate(['/game']);
    }
  }

  checkInstall() {
    const _this = this;
    let installPrompt:any = null;
    const installButton:any = document.querySelector("#install");
    if(!_this.isMobile()){
      installButton.style.display = 'none';
    }

    window.addEventListener("beforeinstallprompt", (event: Event) => {
      event.preventDefault();
      installPrompt = event;
      installButton.removeAttribute("hidden");
      installButton.style.display = 'block'; // assure l'affichage si on est hors Capacitor
    });

    installButton.addEventListener("click", async () => {
      if(_this.isIos()){
        _this._snackBar.openFromComponent(IosSnackBarAnnotatedComponent);
      }else{
        if (!installPrompt) {
          return;
        }
        const result = await installPrompt.prompt();
        console.log(`Install prompt was: ${result.outcome}`);
        installPrompt = null;
        installButton.setAttribute("hidden", "");
      }
    });
  }

  setIsConnected() {
    this.isConnected = this.connector.isConnected();
    if (this.isConnected) {
      this.menuToDisplay = this.connectedMenus;
    } else {
      this.menuToDisplay = [];
    }
  }

  isHome(){
    return this.router.url === '/home';
  }

  colorHere(link: string) {
    if(this.router.url === link){
      return 'accent';
    }
    return 'primary';
  }

  async disconnect() {
    await this.connector.disconnection();
  }

  openPointsHelp(): void {
    this.dialog.open(PointsHelpDialogComponent, {
      width: '90vw',
      maxWidth: '600px',
      maxHeight: '90vh',
      panelClass: 'points-help-dialog-container'
    });
  }

  openSocioCard(): void {
    if (!this.compte || !this.compte.socios || this.compte.socios.length === 0) {
      return;
    }
    this.dialog.open(SocioCardDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      maxHeight: '90vh',
      panelClass: 'socio-card-dialog-container',
      data: {
        socios: this.compte.socios,
        compteId: this.compte.id
      }
    });
  }
}

@Component({
  selector: 'ios-snackbar',
  templateUrl: 'ios.snackbar.html',
  styles: [],
  standalone: false
})
export class IosSnackBarAnnotatedComponent {
  snackBarRef = inject(MatSnackBarRef);
}
